import { IBasicLabelValuePair } from '../models/basic-label-value-pair.model';

export const GetEnumToLabelAndValueOptions = (
  enumType: Record<string, string>
): IBasicLabelValuePair<string>[] => {
  return Object.entries(enumType).map((entry: [string, string]) => {
    return { label: entry[1], value: entry[1] };
  });
};
